import {Grid} from '@mui/material';

import {MatchActivityMetaData} from './MatchActivityMetaData';
import {orangeColors} from '../../../../../../layouts/theme/designSystem';
import {MatchEvent} from '../../../../../../types/MatchActivity';

interface Props {
  event: MatchEvent;
}

export const MatchEventRow = ({event}: Props) => {
  const isCreateEvent = event.activityContent.eventType === 'create';
  return (
    <Grid
      container
      flexWrap='nowrap'
      sx={{
        borderRadius: '8px',
        bgcolor: orangeColors[6],
        p: 1,
      }}
    >
      <Grid item container gap='6px' flexDirection='column' flexGrow={1}>
        <MatchActivityMetaData
          date={event.activityAt}
          authorName={event.activityContent.authorName}
          activityType={isCreateEvent ? 'match-created' : 'status-change'}
          to={event.activityContent.toStatus}
          from={event.activityContent.fromStatus}
        />
      </Grid>
    </Grid>
  );
};
